import { registerCapability } from '../../platform/capability-registry';
import { ImageBlock } from './ImageBlock';
import { IMAGE_ACTION_KEY_LIST, IMAGE_FIELD_KEY_LIST } from './fieldKeys';
import { resolveImagePaths } from './resolvePaths';
import type { ImageBlockOptions } from './types';

registerCapability<ImageBlockOptions>({
  key: 'image',
  fields: [...IMAGE_FIELD_KEY_LIST],
  actions: [...IMAGE_ACTION_KEY_LIST],
  component: ImageBlock,
  defaultPaths: (prefix) => resolveImagePaths(prefix),
  resolvePaths: (prefix, options) => resolveImagePaths(prefix, options),
});
